import * as React from "react";
import { connect } from "react-redux";
import * as toastr from "toastr";

import { IState } from "../../classes/state";

import { MainToolbar } from "./MainToolbar";

import * as actions from "../../actions/calendarSettingsActions";
import * as eventViewActions from "../../actions/eventViewActions";
import * as selectEventsActions from "../../actions/selectEventsFromOtherCalendarsActions";

export class MainToolbarContainer extends React.Component<any, any> {

  public constructor(props: any, context: any) {
    super(props, context);

    this.setCurrentYear = this.setCurrentYear.bind(this);
    this.setCurrentMonth = this.setCurrentMonth.bind(this);
    this.setCurrentDateToToday = this.setCurrentDateToToday.bind(this);
    this.setViewMode = this.setViewMode.bind(this);
    this.setCurrentDateToPreviousPeriod = this.setCurrentDateToPreviousPeriod.bind(this);
    this.setCurrentDateToNextPeriod = this.setCurrentDateToNextPeriod.bind(this);
    this.setEventScreenMode = this.setEventScreenMode.bind(this);
    this.openSelectEventsFromOtherCalendarsModal = this.openSelectEventsFromOtherCalendarsModal.bind(this);
  }

  public setCurrentYear(event) {
    event.preventDefault();
    const newCurrentYear: string = event.currentTarget.attributes["data-year"].value;
    this.props.setCurrentYear(newCurrentYear);
    if (this.props.viewMode !== "MONTHLYLIST") {
      this.props.setViewMode("MONTHLY");
    } else {
      this.props.setViewMode("MONTHLYLIST");
    }
  }

  public setCurrentMonth(event) {
    event.preventDefault();
    const newCurrentMonth: string = event.currentTarget.attributes["data-month-number"].value;
    this.props.setCurrentMonth(newCurrentMonth);
    if (this.props.viewMode !== "MONTHLYLIST") {
      this.props.setViewMode("MONTHLY");
    } else {
      this.props.setViewMode("MONTHLYLIST");
    }
  }

  public setCurrentDateToToday(event) {
    event.preventDefault();
    this.props.setCurrentDateToToday();
  }

  public setEventScreenMode(eventScreenMode: string) {
    this.props.setEventScreenMode(eventScreenMode);
  }

  public setViewMode(event) {
    event.preventDefault();
    const newViewMode: string = event.currentTarget.attributes["data-value"].value;
    this.props.setViewMode(newViewMode);
  }

  public setCurrentDateToPreviousPeriod(event) {
    event.preventDefault();
    this.props.setCurrentDateToPreviousPeriod();
  }

  public setCurrentDateToNextPeriod(event) {
    event.preventDefault();
    this.props.setCurrentDateToNextPeriod();
  }

  public openSelectEventsFromOtherCalendarsModal(event) {
    event.preventDefault();
    this.props.setOpenSelectEventsFromOtherCalendarsModal(true);
  }

  public render() {

    return (
      <MainToolbar
        calendarId={this.props.calendarId}
        calendarName={this.props.calendarName}
        currentDate={this.props.currentDate}
        hasCreatePermission={this.props.hasCreatePermission}
        hasServerData={this.props.hasServerData}
        localFromDate={this.props.localFromDate}
        localToDate={this.props.localToDate}
        numAjaxCallsInProgress={this.props.numAjaxCallsInProgress}
        portalId={this.props.portalId}
        pageId={this.props.pageId}
        pageName={this.props.pageName}
        objectId={this.props.objectId}
        contextId={this.props.contextId}
        parentId={this.props.parentId}
        portletInstanceId={this.props.portletInstanceId}
        selectedDate={this.props.selectedDate}
        text={this.props.text}
        todaysDate={this.props.todaysDate}
        useModernAddAndEditEventScreen={this.props.useModernAddAndEditEventScreen}
        viewMode={this.props.viewMode}
        viewModeOptions={this.props.viewModeOptions}
        onRequestServersForCalendar={this.props.onRequestServersForCalendar}
        onSetCurrentYear={this.setCurrentYear}
        onSetCurrentMonth={this.setCurrentMonth}
        onSetCurrentDateToToday={this.setCurrentDateToToday}
        onSetEventScreenMode={this.setEventScreenMode}
        onSetViewMode={this.setViewMode}
        onSetCurrentDateToPreviousPeriod={this.setCurrentDateToPreviousPeriod}
        onSetCurrentDateToNextPeriod={this.setCurrentDateToNextPeriod}
        onOpenSelectEventsFromOtherCalendarsModal={this.openSelectEventsFromOtherCalendarsModal}
        onClearEvent={this.props.setClearEvent}
      />
    );
  }

}

const mapStateToProps = (state: IState, ownProps: any) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.
  return {
    calendarId: state.calendarSettings.calendarId,
    calendarName: state.calendarSettings.calendarName,
    contextId: state.calendarSettings.contextId,
    currentDate: state.calendarSettings.currentDate,
    hasCreatePermission: state.calendarSettings.hasCreatePermission,
    hasServerData: state.selectEventsFromOtherCalendarsSettings.hasServerData,
    localFromDate: state.calendarSettings.localFromDate,
    localToDate: state.calendarSettings.localToDate,
    numAjaxCallsInProgress: state.numAjaxCallsInProgress,
    objectId: state.calendarSettings.objectId,
    pageId: state.calendarSettings.pageId,
    pageName: state.calendarSettings.pageName,
    parentId: state.calendarSettings.parentId,
    portalId: state.calendarSettings.portalId,
    portletInstanceId: state.calendarSettings.portletInstanceId,
    selectedDate: state.calendarSettings.selectedDate,
    text: state.text,
    todaysDate: state.calendarSettings.todaysDate,
    useModernAddAndEditEventScreen: state.calendarSettings.useModernAddAndEditEventScreen,
    viewMode: state.calendarSettings.viewMode,
    viewModeOptions: state.calendarSettings.viewModeOptions,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRequestServersForCalendar: (portletInstanceId: number, calendarId: number) => {
      dispatch(selectEventsActions.requestServersForCalendar(portletInstanceId, calendarId));
    },
    setClearEvent: () => {
      const action = eventViewActions.clearCurrentCalendarEvent();
      dispatch(action);
    },
    setCurrentDateToNextPeriod: () => {
      dispatch(actions.setCurrentDateToNextPeriod());
    },
    setCurrentDateToPreviousPeriod: () => {
      dispatch(actions.setCurrentDateToPreviousPeriod());
    },
    setCurrentDateToToday: () => {
      dispatch(actions.setCurrentDateToToday());
    },
    setCurrentMonth: (monthNumber: number) => {
      dispatch(actions.setCurrentMonth(monthNumber));
    },
    setCurrentYear: (year: number) => {
      dispatch(actions.setCurrentYear(year));
    },
    setEventScreenMode: (eventScreenMode: string) => {
      dispatch(actions.setEventScreenMode(eventScreenMode));
    },
    setOpenSelectEventsFromOtherCalendarsModal: (open: boolean) => {
      dispatch(selectEventsActions.setOpenSelectEventsFromOtherCalendarsModal(open));
    },
    setViewMode: (viewMode: string) => {
      dispatch(actions.setViewMode(viewMode));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainToolbarContainer);
